import React, { useEffect } from "react";

// Extend the Window interface to include ZOHOIM and ZohoDesk properties
declare global {
  interface Window {
    ZOHOIM: any;
    ZohoDeskAsapReady?: (callback: () => void) => void;
    ZohoDeskAsap__asyncalls?: Array<() => void> | null;
    ZohoDeskAsapReadyStatus?: boolean;
  }
}

const ZohoChatWidget: React.FC = () => {
  useEffect(() => {
    // Generate a random Base64 string for the nonce
    const generateNonce = () => {
      const array = new Uint8Array(16);
      window.crypto.getRandomValues(array);
      return btoa(String.fromCharCode(...array));
    };

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "zohodeskasapscript";
    script.defer = true;
    script.nonce = generateNonce(); // Replace with a random Base64 string
    script.src =
      "https://desk.zoho.com/portal/api/web/asapApp/174469000031945011?orgId=642484567";

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode?.insertBefore(script, firstScript);

    window.ZohoDeskAsapReady = function (callback) {
      const asyncCalls = (window.ZohoDeskAsap__asyncalls =
        window.ZohoDeskAsap__asyncalls || []);
      if (window.ZohoDeskAsapReadyStatus) {
        if (callback) asyncCalls.push(callback);
        asyncCalls.forEach((cb) => cb && cb());
        window.ZohoDeskAsap__asyncalls = null;
      } else if (callback) {
        asyncCalls.push(callback);
      }
    };

    // Cleanup script on component unmount
    return () => {
      const existingScript = document.getElementById("zohodeskasapscript");
      if (existingScript) {
        existingScript.parentNode?.removeChild(existingScript);
      }
    };
  }, []);

  return null; // This component doesn't render any visible elements
};

export default ZohoChatWidget;
